import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faTwitter,
  faInstagram,
  faXTwitter,
  faSquareXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";

library.add(faTwitter, faInstagram, faEnvelope, faXTwitter);

// faXTwitter
